import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-donation-dialog',
    imports: [
        RouterLink,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule
    ],
    templateUrl: './donation-dialog.component.html',
    styleUrl: './donation-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DonationDialogComponent {
  /**
   * DI
   */
  public dialogRef = inject(MatDialogRef<DonationDialogComponent>);
  private readonly clipboardService = inject(Clipboard);
  private readonly snackBarService = inject(MatSnackBar);

  /**
   * Method to copy item to clipboard
   */
  copyToClipboard( subject: string, value: string) {
    this.clipboardService.copy(value);
    this.snackBarService.open(`${subject} in Zwischenablage kopiert`, 'OK', {
      duration: 5000,
    });
  }

}
